import { render, staticRenderFns } from "./ComplainOrder.vue?vue&type=template&id=5b8aca3e&scoped=true&"
import script from "./ComplainOrder.vue?vue&type=script&lang=ts&"
export * from "./ComplainOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ComplainOrder.vue?vue&type=style&index=0&id=5b8aca3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8aca3e",
  null
  
)

export default component.exports